const React = require('react');
const { forwardRef } = require('react');
const T = require('prop-types');
const { default: ListItemButton } = require('@mui/material/ListItemButton');

const AppMenuItemComponent = forwardRef((props, ref) => {

    const {
        className,
        onClick,
        link,
        children,
        tabIndex = 0,
        ...rest
    } = props;

    return (
        <ListItemButton
            component='li'
            className={className}
            onClick={onClick}
            ref={ref}
            tabIndex={tabIndex}
            {...rest}
        >
            {children}
        </ListItemButton>
    );
});

AppMenuItemComponent.displayName = 'AppMenuItemComponent';

AppMenuItemComponent.propTypes = {
    className: T.string,
    link: T.string,
    onClick: T.func,
    children: T.any,
    tabIndex: T.number
};

module.exports = AppMenuItemComponent;
